import { format } from 'date-fns'

/**
 * Formats a date object to a string in the format "Year-Month-Day"
 * @param date - The date object to format
 * @returns A string in the format "Year-Month-Day"
 */
export function formatDateToShortFormat(date: Date) {
  return format(date, 'yyyy-MM-dd')
}

/**
 * Formats a date object to a string in the format "Day Month, Year"
 * If a to date is provided, it will format the date in the format "Day Month - Day Month, Year"
 * @param date - The date object to format
 * @param to - The to date object to format
 * @returns A string in the format "Day Month, Year" or "Day Month - Day Month, Year"
 */
export function formatDateForDisplay(date: Date, to?: Date) {
  if (to) return `${format(date, 'dd MMM')} - ${format(to, 'dd MMM, yyyy')}`

  return format(date, 'dd MMM, yyyy')
}
